module.exports = __webpack_public_path__ + "img/486-2d1e07.png";